module.exports = __webpack_public_path__ + "img/icon_top_yushou_pre.d5519547.png";